import axios from 'axios';

const instance = axios.create({
    baseURL: 'https://tgc-api.nassoftwarecorp.com/api',
    // baseURL: "https://dgrv4nm2pj.us-east-1.awsapprunner.com/api"
});

instance.interceptors.request.use(
  async (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    // config.headers['Content-Type'] = 'multipart/form-data'
    return config;
  },
  (err) => {
    return Promise.reject(err);
  }
);

export default instance;
